module.exports = __webpack_public_path__ + "img/dred-scott.bf08b4bb.png";